import React, { ReactNode } from "react";
import { ReactComponent as ArrowIcon } from "../../assets/arrow.svg";

import styled from "styled-components";

interface AccordionProps {
  title: string;
  children?: ReactNode;
  isOpen: boolean;
  onClick: Function;
}

const Accordion = ({ title, children, isOpen, onClick }: AccordionProps) => {
  return (
    <AccordionSection>
      <AccordionTitle onClick={() => onClick()}>
        {title}
        <IconContainer isOpen={isOpen}>
          <ArrowIcon />
        </IconContainer>
      </AccordionTitle>
      <AccordionContent isOpen={isOpen}>{children}</AccordionContent>
    </AccordionSection>
  );
};

const AccordionSection = styled.div`
  display: flex;
  flex-direction: column;
`;

const AccordionTitle = styled.button`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fafafa;
  color: #212529;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%; /* 16.8px */
  cursor: pointer;
  padding: 9px 0;
  border: none;
  text-align: left;
  outline: none;
  border-bottom: 2px solid #e5e5e5;
`;

const AccordionContent = styled.div<{ isOpen: boolean }>`
  overflow: auto;
  max-height: ${({ isOpen }) => {
    return isOpen ? "180px" : "0px";
  }};
`;

const IconContainer = styled.div<{ isOpen: boolean }>`
  transition: transform 0.1s ease;
  transform: rotate(${({ isOpen }) => (isOpen ? "180deg" : 0)});
`;

export default Accordion;
